import { render, staticRenderFns } from "./MetricHolder.vue?vue&type=template&id=2c857bd8&scoped=true&"
import script from "./MetricHolder.vue?vue&type=script&lang=ts&"
export * from "./MetricHolder.vue?vue&type=script&lang=ts&"
import style0 from "./MetricHolder.vue?vue&type=style&index=0&id=2c857bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c857bd8",
  null
  
)

export default component.exports